<div class="vehicle-speed-wrapper">
    <div
        [ngClass]="{ 
            'is-speed-max': value >= maxSpeed,
            'no-speed-max': value < maxSpeed
        }"
        class="vehicle-speed"
    >
        <span>
            {{ value | number: '1.0-0' }} km/h
        </span>                                       
    </div>
</div>
